module.exports = __webpack_public_path__ + "static/brand_finelite_banner-a4a81fc0de0d2e4e7d4d2875909ff8e6.png";